<script>
import { RouterLink } from "vue-router";

export default {
  props: {
    heading: String,
    message: String,
    link: {
      type: String,
      default: "#",
    },
    button: String,
  },
  computed: {
    isInternal() {
      // any link starting with `/` is treated as an internal route
      return this.link.startsWith("/");
    },
  },
  components: { RouterLink },
};
</script>

<template>
  <div class="container my-5">
    <div class="p-5 text-center fcp-bg-primary rounded-3 text-white">
      <h1 class="text-white">{{ heading }}</h1>
      <div class="yellow-dash"></div>
      <p class="lead px-md-5 text-break">
        {{ message }}
      </p>

      <!-- If it's an internal link -->
      <RouterLink
        v-if="isInternal"
        :to="link"
        class="btn btn-outline-warning rounded-pill px-3 py-2"
        v-scrollanimation.once="'fadeInUp'"
      >
        {{ button }}
      </RouterLink>

      <!-- If it's an external link (mailto, tel, http, etc.) -->
      <a
        v-else
        :href="link"
        class="btn btn-outline-warning rounded-pill px-3 py-2"
        v-scrollanimation.once="'fadeInUp'"
        target="_blank"
        rel="noopener"
      >
        {{ button }}
      </a>
    </div>
  </div>
</template>

<style scoped></style>
